/** @jsxImportSource @emotion/react */
import { useLocation, useNavigate } from "react-router-dom";
import MeetingRoomStatusDashboard from "../analytics/meeting/MeetingRoomStatusDashboard/MeetingRoomStatusDashboard";
import VisitorsDashboard from "../analytics/visitors/dashboard";
import MeetingDataTable from "../analytics/meeting/data-table";
import VisitorsDataTable from "../analytics/visitors/data-table";
import { notUserRoles, securityAdminRoles } from "utils/role";
import ProtectedRoute from "ProtectedRoute";
import Root from "pages/root";
import { useRecoilValue } from "recoil";
import { workspace } from "recoil/recoilState";

export default function MeetingNavigation() {
  const location = useLocation().pathname;
  const paths = decodeURIComponent(location).split("/");
  const navigate = useNavigate();
  const workspaceInfo = useRecoilValue(workspace);

  const pathLength = paths.length;
  switch (pathLength) {
    case 3:
      if (paths[2] === "Mile Meeting") {
        navigate("/analytics/Mile Meeting/회의실 현황 대시보드");
        return;
      } else {
        navigate("/analytics/Mile Visitors/방문자 현황 대시보드");
        return;
      }
    case 2:
      navigate("/analytics/Mile Meeting/회의실 현황 대시보드");
      return;
    default:
      break;
  }

  const getPage = () => {
    switch (paths[2]) {
      case "Mile Meeting":
        if (paths[3] === "회의실 현황 대시보드") {
          return (
            <ProtectedRoute element={<MeetingRoomStatusDashboard />} page={paths[3]} accessRoles={securityAdminRoles} />
          );
        } else {
          return <ProtectedRoute element={<MeetingDataTable />} page={paths[3]} accessRoles={securityAdminRoles} />;
        }
      case "Mile Visitors":
        if (paths[3] === "방문자 현황 대시보드") {
          return (
            <ProtectedRoute
              element={<VisitorsDashboard />}
              page={paths[3]}
              accessRoles={workspaceInfo?.mileVisitorsUsage ? securityAdminRoles : notUserRoles}
            />
          );
        } else {
          return (
            <ProtectedRoute
              element={<VisitorsDataTable />}
              page={paths[3]}
              accessRoles={workspaceInfo?.mileVisitorsUsage ? securityAdminRoles : notUserRoles}
            />
          );
        }
    }
  };

  return (
    <>
      <Root>{getPage()}</Root>
    </>
  );
}
